export class GaElementModifierComponent {
  containerClassName = 'js-ga-button-wrapper';

  buttonClassName = 'js-ga-button';

  constructor() {

  }

  initialize() {
    this.updateButtonClasses();
  }

  updateButtonClasses() {
    const containers = document.querySelectorAll(`.${this.containerClassName}`);
    if (!containers.length) {
      return;
    }

    Array.from(containers).forEach((container) => {
      let button = container.querySelector('a.elementor-button');
      if (button) {
        const id = container.getAttribute('id');
        container.removeAttribute('id');
        container.classList.remove(this.containerClassName);

        button.classList.add(this.buttonClassName);
        button.classList.add(`ga-${id}`);
      }
    });
  }
}